import EventEmitter from 'src/helpers/EventEmitter'
import store from 'src/store'

import ImageService from '@/services/ImageService' 
const THREE = require('three')

import TextureCache from 'src/helpers/TextureCache'

import FacesSpritesheet from '@/assets/sprites/faces' 
import BubblesSpritesheet from '@/assets/sprites/bubbles' 
import MovieClip from 'src/helpers/MovieClip' 
  
class Bg extends THREE.Group { 

  constructor(config) {

    super();
  
    Object.assign(this, EventEmitter)  
  
    this.position.y = 50;
    this.position.z = -400;
    this.NUM_OF_EXPRESSIONS = 10;
    this.count = 0;
    this.initalShow = true;

    this.tweenObj = {
      yOffset: 50
    }
    
    this.setup(); 
    this.resize() 
  }

  setup(){

    let bubbles_texture = TextureCache.createTexture(require('@/assets/sprites/bubbles.png'), {});
    let spritesheet_texture = TextureCache.createTexture(require('@/assets/sprites/faces.png'), {});
    let width = 1024;
    let height = 1024;

    this.face_bg_mc = new MovieClip({ 
      frames: FacesSpritesheet.frames,
      frame_width: width,
      frame_height: height, 
      spritesheet_width: FacesSpritesheet.meta.size.w,
      spritesheet_height: FacesSpritesheet.meta.size.h, 
      texture: spritesheet_texture
    }); 
    this.face_bg_mc.position.z = -3;
    this.face_bg_mc.scale.x = this.face_bg_mc.scale.y = 0.5;
    this.face_bg_mc.gotoAndStop('bust.png') 
    this.add(this.face_bg_mc)
 
    this.face_plate_mc = new MovieClip({ 
      frames: FacesSpritesheet.frames,
      frame_width: width,
      frame_height: height, 
      spritesheet_width: FacesSpritesheet.meta.size.w,
      spritesheet_height: FacesSpritesheet.meta.size.h, 
      texture: spritesheet_texture,
      transparent: true
    }); 
    this.face_plate_mc.position.z = -2;
    this.face_plate_mc.scale.x = this.face_plate_mc.scale.y = 0.5;
    this.face_plate_mc.gotoAndStop('idle_ready.png') 
    this.add(this.face_plate_mc)

    this.headphones_mc = new MovieClip({ 
      frames: FacesSpritesheet.frames,
      frame_width: width,
      frame_height: height, 
      spritesheet_width: FacesSpritesheet.meta.size.w,
      spritesheet_height: FacesSpritesheet.meta.size.h, 
      texture: spritesheet_texture
    });
    this.headphones_mc.position.x = 4;
    this.headphones_mc.position.z = -1;
    this.headphones_mc.scale.x = this.headphones_mc.scale.y = 0.5;
    this.headphones_mc.gotoAndStop('headphones.png') 
    this.add(this.headphones_mc)

    this.red_cheeks_mc = new MovieClip({ 
      frames: FacesSpritesheet.frames,
      frame_width: 1024,
      frame_height: 1024, 
      spritesheet_width: FacesSpritesheet.meta.size.w,
      spritesheet_height: FacesSpritesheet.meta.size.h, 
      texture: spritesheet_texture
    });
    this.red_cheeks_mc.position.z = 1;
    this.red_cheeks_mc.scale.x = this.red_cheeks_mc.scale.y = 0.5;
    this.red_cheeks_mc.gotoAndStop('furious_cheeks.png');
    this.red_cheeks_mc.visible = false;   
    this.add(this.red_cheeks_mc)

    this.silhouette = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.5, 1024  * 0.5), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/silhouette.png')),
        transparent: true
      })
    );
    this.silhouette.position.z = 1;  
    this.add(this.silhouette)


    this.burp_mc = new MovieClip({ 
      frames: BubblesSpritesheet.frames,
      frame_width: 1024,
      frame_height: 1024, 
      spritesheet_width: BubblesSpritesheet.meta.size.w,
      spritesheet_height: BubblesSpritesheet.meta.size.h, 
      texture: bubbles_texture
    });
    this.burp_mc.position.z = 3;
    this.burp_mc.scale.x = this.burp_mc.scale.y = 0.5;  
    this.add(this.burp_mc)

  }

  onIdleBored = () => { 
    this.burp_mc.visible = true;
    this.burp_mc.gotoAndPlayRange(0, 6, ()=>{ this.burp_mc.visible = false; }, 4);
    this.face_plate_mc.gotoAndStop('idle_bored.png') 
    TweenMax.delayedCall(1 + Math.random() , this.onIdleBoredReset);
  }

  onIdleBoredReset = () => {
    this.face_plate_mc.gotoAndStop('idle_ready.png')
    TweenMax.delayedCall(10 + Math.random() * 5, this.onIdleBored);
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img); 
    texture.magFilter = THREE.LinearFilter;
    texture.minFilter = THREE.LinearFilter;  
    texture.needsUpdate = true;
    return texture;
  }
  
  updateOffset(texture, x, y){ 
    texture.offset = new THREE.Vector2(x, y);
  }

  tick(tap_hold_ratio) {
    let ratio = window.Power2.easeInOut.getRatio( tap_hold_ratio) ;
    this.scale.x = this.scale.y =  1 - (ratio * 0.15);
    this.position.y = this.tweenObj.yOffset + Math.sin(this.count) * 20; 
    this.count += 0.015;
  }

  idle() {

    this.headphones_mc.visible = true;
    this.face_plate_mc.gotoAndStop('idle_ready.png') 
    this.red_cheeks_mc.visible = false;   
    this.face_bg_mc.visible = true;

    TweenMax.delayedCall(10 + Math.random() * 5, this.onIdleBored);
  
    this.initalShow = false;
  }

  tapholdProgress() {
    TweenMax.killTweensOf([this.onIdleBored, this.onIdleBoredReset]);
  }
  
  tapholdRecord() {  
    this.headphones_mc.visible = false;
  }

  tapholdRelease() {}
    
  processing() {
    this.face_plate_mc.gotoAndStop('loading.png') 
    // this.bgMesh.visible = false;
  }
    
  complete(val) { 

    switch(val) {
      case 0:
        this.furious();
        break;
      case 1:
        this.sad();
        break;
      case 2:
        this.angry();
        break;
      case 3:
        this.agitated();
        break;
      case 4:
        this.confused();
        break;
      case 5:
        this.mildlyamused();
        break;
      case 6:
        this.amused();
        break;
      case 7:
        this.happy();
        break;
      case 8:
        this.ecstatic();
        break;
      case 9:
        this.error();
        break;
    }
    // this.face_bg_mc.visible = false;
    
    if(val !== 9){
      TweenMax.to(this.tweenObj, 3, {
        yOffset: 120, 
        ease: 'Back.easeInOut'
      })  
    }
    
  }

  result(val){ }

  furious(){
    this.face_plate_mc.gotoAndStop('01_furious.png') 
    this.red_cheeks_mc.visible = true;   
  }

  sad(){
    this.face_plate_mc.gotoAndStop('02_sad.png') 
  }

  angry(){
    this.face_plate_mc.gotoAndStop('03_angry.png') 
  }

  agitated(){
    this.face_plate_mc.gotoAndStop('04_agitated.png') 
  }

  confused(){
    this.face_bg_mc.visible = false;
    this.face_plate_mc.gotoAndStop('05_confused.png') 
  }

  mildlyamused(){ 
    this.face_plate_mc.gotoAndStop('06_amused.png') 
  }
  
  amused(){ 
    this.face_plate_mc.gotoAndStop('07_mildly-happy.png') 
  }

  happy(){ 
    this.face_plate_mc.gotoAndStop('08_happy.png') 
  }

  ecstatic(){ 
    this.face_plate_mc.gotoAndStop('09_ecstatic.png') 
  }
  
  error(){ 
    this.face_plate_mc.gotoAndStop('error.png') 
  }
  
  updateRoute(val) {
     if(val.name === 'question'){

      TweenMax.to(this.position, 5, {
        z: 0,
        ease: 'Expo.easeOut'
      })
      TweenMax.to(this.silhouette.material, 2, {
        opacity: 0,
        ease: 'Sine.easeInOut'
      })

    } else if(val.name === 'result') {

       TweenMax.to(this.silhouette.material, 1, {
        opacity: 1,
        ease: 'Quad.easeInOut'
      }) 
      TweenMax.to(this.position, 2, {
        z: -170, 
        ease: window.Back.easeInOut.config(2)
      }) 
      TweenMax.to(this.tweenObj, 2, {
        yOffset:  50, 
        ease: 'Power3.easeInOut'
      })  
      this.face_bg_mc.visible = true;
      this.face_plate_mc.gotoAndStop('idle_ready.png') 
    }
  }

  updateState(val){}
 
  resize() {  }
 
 
}

export default Bg